import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { isEqual } from "lodash-es";
import { map } from "rxjs/operators";

import { ProductBlockAction } from "../product-block/product-block.action";
import { ProductBlock } from "../product-block/product-block.model";

import { CasinoBlockAction } from "./casino-block.action";
import { CasinoBlockUpdate } from "./casino-block.model";

@Injectable()
export class CasinoBlockEffect {
	update$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ProductBlockAction.getSuccess, ProductBlockAction.updateSuccess),
			map((payload) => CasinoBlockAction.update(this.getCasinoBlockFromProductBlock(payload.products)))
		)
	);

	clear$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ProductBlockAction.clear),
			map(() => CasinoBlockAction.clear())
		)
	);

	constructor(private actions$: Actions) {}

	private getCasinoBlockFromProductBlock(products: ProductBlock[]): CasinoBlockUpdate {
		return {
			isCasinoBlocked: isEqual(
				products.filter((product) => !product.isBlocked).map((product) => product.classificationName),
				["Sportsbook"]
			),
			isPlayerProfileSelected:
				new Date(Math.max(...products.map((e) => new Date(e.lastModified!).getTime()))) >
				new Date("2020-06-01T00:00:00"),
		};
	}
}
